import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Anteproy_condominioComponent = /** @class */ (function () {
    function Anteproy_condominioComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            superficie: new FormControl(''),
            cantidad: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("anteproy_condominio"))) {
            localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("anteproy_condominio"));
            this.form.controls['superficie'].setValue(this.rows[0] ? this.rows[0].superficie : '');
            this.form.controls['cantidad'].setValue(this.rows[0] ? this.rows[0].cantidad : '');
        }
    }
    Anteproy_condominioComponent.prototype.add_anteproy_condominio = function () {
        localStorage.setItem("anteproy_condominio", JSON.stringify([]));
        this.actualRow = localStorage.getItem("anteproy_condominio");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superficie: this.form.value.superficie,
            cantidad: this.form.value.cantidad
        });
        localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
    };
    Anteproy_condominioComponent.prototype.delete_anteproy_condominio = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("anteproy_condominio", JSON.stringify(this.rows));
            }
        }
    };
    return Anteproy_condominioComponent;
}());
export { Anteproy_condominioComponent };
